import { _ } from "js/vendor";
import {
    LOAD_THEME,
    UPDATE_THEME,
    fontsActions,
    UPLOAD_FONT,
    RESET_THEME,
    SET_CUSTOM_FONT
} from "js/react/views/ThemeEditor/themeEditor_types";

const defaultState = { model: {}, attributes: {}, customFonts: { list: [] } };

const throttledModelSet = _.throttle((state, payload) => {
    state.model.set(payload);
}, 500);

export default function themeEditorReducer(state = defaultState, action) {
    let { type, payload, result } = action;

    switch (type) {
        case LOAD_THEME:
            return {
                ...state,
                model: payload.theme,
                originalTheme: payload.originalTheme,
                attributes: payload.theme.attributes
            };

        case RESET_THEME:
            return defaultState;

        case UPDATE_THEME:
            // if we're updating to gradient, and not already set to gradient, save the default background color
            if (
                ["gradient", "reverseGradient"].includes(
                    payload.styleBackground
                ) &&
                !["gradient", "reverseGradient"].includes(
                    state.model.get("styleBackground")
                )
            ) {
                payload.lastDefaultBackgroundColor = state.model.get(
                    "defaultBackgroundColor"
                );
            } else if (payload.defaultBackgroundColor) {
                payload.lastDefaultBackgroundColor =
                    payload.defaultBackgroundColor;
            }

            throttledModelSet(state, payload);
            return { ...state, attributes: { ...state.model.attributes } };

        case fontsActions.fetchStart:
            return {
                ...state,
                customFonts: { ...state.customFonts, status: "started" }
            };

        case fontsActions.fetchSuccess:
            return {
                ...state,
                customFonts: {
                    ...state.customFonts,
                    list: result,
                    status: "success"
                }
            };

        case fontsActions.fetchError:
            return {
                ...state,
                customFonts: {
                    ...state.customFonts,
                    error: result,
                    status: "error"
                }
            };

        case UPLOAD_FONT:
            return {
                ...state,
                customFonts: {
                    ...state.customFonts,
                    list: [payload, ...state.customFonts.list]
                }
            };

        case SET_CUSTOM_FONT:
            const asset = payload.asset;
            const id = asset.id;
            const fontName = asset.get("name");
            const hasRegular = asset.get("regular");
            const hasItalic = asset.get("italic");
            const hasBold = asset.get("bold");
            const hasBoldItalic = asset.get("bolditalic");
            const regularFont = `${id}/regular`;
            const italicFont = `${id}/italic`;
            const boldFont = `${id}/bold`;
            const boldItalicFont = `${id}/bolditalic`;

            if (!hasRegular) throw new Error(`No regular font for asset ${id}`);

            state.model.set({
                [`${payload.attribute}`]: fontName,
                [`${payload.attribute}Regular`]: regularFont,
                [`${payload.attribute}Italic`]: hasItalic
                    ? italicFont
                    : regularFont,
                [`${payload.attribute}Emphasized`]: hasBold
                    ? boldFont
                    : regularFont,
                [`${payload.attribute}EmphasizedItalic`]: hasBoldItalic
                    ? boldItalicFont
                    : hasBold
                        ? boldFont
                        : hasItalic
                            ? italicFont
                            : regularFont,
                [`${payload.attribute}LineHeight`]: 1.6,
                [`${payload.attribute}LetterSpacing`]: 0,
                [`${payload.attribute}TextTransform`]: "auto",
                [`${payload.attribute}Scaling`]: 100
            });
            return { ...state, attributes: { ...state.model.attributes } };
        default:
            return state;
    }
}
